import * as React from "react";
import { FunctionComponent,useEffect,useState} from 'react';
import { ClaimType } from "../Models/Claim";

interface ClaimSuccessProps
{
    claimNumber: string;
    claimType: ClaimType;
};
export const ClaimSuccess: FunctionComponent<ClaimSuccessProps> = ({claimNumber, claimType}) => {
    const[firstLoad, setFirstLoad] = useState<boolean>(true);
    useEffect(() =>{
        if(firstLoad)
        {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            setFirstLoad(false);
        }
    },[firstLoad])
    return <div className="success-step">
        <div className="success-header">
            <h3>Success!</h3>
        </div>
        <div className="success-content">
            <p>Thank you!  Your claim has been reported and a copy of the loss notice has been sent to your email address.</p>
            <p><strong>Your claim number will be {claimNumber}.</strong></p>
            <p>You can expect us to contact you within one business day.</p>
            {claimType == ClaimType.Property ?<p>In the meantime, please take any necessary steps to protect your property from any further damage, and do not discard any items before we can meet with you.</p> : null}
        </div>
    </div>;
}
